import i18next from 'i18next';

import { useEffectOnce } from '~/hooks/useEffectOnce';
import { FALLBACK_LNG } from '~/i18n/config';

export function useInitLanguage() {
  useEffectOnce(() => {
    i18next.changeLanguage(FALLBACK_LNG);
  });
}
